<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>
<style lang="scss">
@import "./assets/css/main.css";
@import "./assets/css/base.scss";//解决下拉框抖动问题
@import "./assets/css/color-dark.css"; /*深色主题*/
/*@import "./assets/css/theme-green/color-green.css";   浅绿色主题*/
body .el-table th.gutter {
  display: table-cell !important;
}
.el-menu.el-menu--popup.el-menu--popup-right-start {
  background: #fff !important;
}
.a-link {
  text-decoration: underline;
  color: #f8ab01;
  cursor: pointer;
}
.el-autocomplete-suggestion.el-popper {
  width: auto !important;
}
.el-table__body .el-radio .el-radio__label {
  display: none;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.el-link.is-underline:hover:after {
  border: none !important;
}
.colorBtn .el-button {
  margin-right: 10px !important;
  background: #f8ab01 !important;
  color: #fff !important;
  border-color: #f8ab01 !important;
}
.el-tooltip__popper.is-dark {
  margin-left: 20px !important;
}
.el-tooltip__popper.is-dark.prod__record {
  margin-left: 0 !important;
}
.flexBox {
  width: 100%;
  .el-form-item__content {
    display: -moz-box; /* Firefox */
    display: -ms-flexbox; /* IE10 */
    display: -webkit-box; /* Safari */
    display: -webkit-flex; /* Chrome, WebKit */
    display: flexbox;
    display: flex;
    display: flex !important;
  }
}
.el-input.is-disabled .el-input__inner {
  color: #606266 !important;
}
.el-textarea.is-disabled .el-textarea__inner {
  color: #606266 !important;
}
.el-range-editor.is-disabled input {
  color: #606266 !important;
}
.el-range-editor.is-disabled .el-range-separator {
  color: #606266 !important;
}
.is-disabled.el-input .el-input__inner:-ms-input-placeholder {
  color: #c0c4cc !important;
}
textarea {
  font-family: "PingFang SC", "Helvetica Neue", Helvetica, "microsoft yahei",
    arial, STHeiTi, sans-serif;
}
</style>
<script>
export default {
  name: 'app',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
